<div class="-login row">
  <div class="col-12 img-fondo-login"></div>
  <div class="col-12 space-fondo-login d-flex justify-content-center align-items-center">
    <div class="login-container">
      <div class="login-card gap-2 d-flex flex-column">
        <div class="text-start d-flex flex-column align-items-start">
          <span class="text-174D9C text-montserrat text-800 text-18 mb-0">Te damos la bienvenida</span>
          <span class="text-2A2A59 text-montserrat text-800 text-18 mb-3">Portal Relator</span>
        </div>
  
        <form [formGroup]="loginForm">
          <div class="mb-3">
            <label for="username" class="form-label text-14 text-000000 text-600 text-nunito">Usuario</label>
            <input type="text" formControlName="username" class="form-control" id="username" placeholder="Nombre usuario" />
            @if (loginForm.get('username')?.invalid && loginForm.get('username')?.touched) {
              <span class="text-danger text-12">Usuario es requerido.</span>
            }
          </div>
          <div class="mb-5">
            <label for="password" class="form-label text-14 text-000000 text-600 text-nunito w-100 d-flex align-items-center justify-content-between">
              <span>Contraseña</span>
              <img
                  class="me-3"
                  [src]="mostrarContrasena ? './assets/icons/see-off.svg' : './assets/icons/see-on.svg'" 
                  alt="Mostrar/Ocultar" 
                  style="cursor: pointer; position: relative; top: 37px;"
                  width="20px" 
                  (click)="mostrarContrasena = !mostrarContrasena"
                />
            </label>
            <input [type]="mostrarContrasena ? 'text' : 'password'" formControlName="password" class="form-control"
              maxlength="30" id="password" placeholder="Escriba su contraseña" />
            @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
              <span class="text-danger text-12">Contraseña es requerida.</span>
            }
          </div>
          <button type="button" (click)="onLogin('rutDni')" class="btn btn-blue w-100">
            Entrar
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
